// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"708a3c75","359":"2a70727c","361":"317607c8","511":"98af425a"}[chunkId] + ".chunk.js";
};